import React, { useEffect } from "react";
import { GridItem, GridContainer } from "./MerchantAndTerminals.styles";
import TextField from "../../textField/TextField";
import SelectField from "../../selectField/SelectField";
import CurrencySelectField from "../../selectField/CurrencySelectField";
import MccSelectField from "../../selectField/MccSelectField";
import { useSelector } from "react-redux";

const AcquirerFields = ({
  formValues,
  handleChange,
  handleBlur,
  errors,
  touched,
  acquirerData,
  readOnly = false,
}) => {
  const { formType } = useSelector((state) => state.merchantAndTerminals);

  const {
    acquirer: {
      iso,
      isoID,
      email,
      currency,
      name,
      address,
      merchantID,
      mccID,
      city,
      merchantState,
      postalCode,
      holding,
      holdingId,
    },
    merchant: {
      business_email,
      legal_name,
      business_phone,
      business_type,
      taxpayer_id,
    },
  } = formValues;

  const businessTypeOptions = (currency = "USD") => {
    if (currency === "MXN") {
      return [
        "SA de CV",
        "SAPI de CV",
        "SC",
        "S de RL",
        "SAS",
        "SNC",
        "S en CS",
        "S en C por A",
      ];
    }

    if (currency === "BOB") {
      return ["SA", "SRL", "EU", "SC", "SCS", "SCA", "SAM"];
    }
    return [
      "Sole Pro",
      "Corp.",
      "LLC",
      "Partner.",
      "Non-Pro.",
      "Gov.",
      "Other",
    ];
  };

  // UseEffect to set acquirer data in the form
  // execute when 1st step component is mounted
  // useEffect(() => {
  //   if (acquirerData?.isoID) {
  //     handleChange({ target: { name: "acquirer.iso", value: "True" } });
  //     handleChange({
  //       target: { name: "acquirer.isoID", value: acquirerData.isoID },
  //     });
  //   } else {
  //     handleChange({ target: { name: "acquirer.iso", value: "False" } });
  //   }
  //   if (acquirerData?.currency_code) {
  //     handleChange({
  //       target: {
  //         name: "acquirer.currency",
  //         value: acquirerData.currency_code,
  //       },
  //     });
  //   }
  //   handleChange({ target: { name: "acquirer.amountOther", value: "False" } });
  //   handleChange({ target: { name: "acquirer.store", value: "0001" } });
  // }, [acquirerData, handleChange]);

  const isoOptions = [
    { value: "True", label: "True" },
    { value: "False", label: "False" },
  ];

  // Solo mostrar holding y holdingId en editTerminal o seeTerminal
  const showHoldingFields =
    formType === "editTerminal" || formType === "seeTerminal";

  // On merchant creation the Merchant ID is auto-generated (UUID) and hidden from
  // the form. It stays visible (read-only) when editing/viewing an existing merchant.
  const isCreating = formType === "createEnrollment";

  useEffect(() => {
    if (isCreating && !merchantID) {
      handleChange({
        target: { name: "acquirer.merchantID", value: crypto.randomUUID() },
      });
    }
  }, [isCreating, merchantID, handleChange]);

  const sanitizeNoSpaceValue = (value) => value.replace(/\s+/g, "");

  const sanitizeBusinessPhone = (value) => {
    const hasLeadingPlus = value.startsWith("+");
    const digitsOnly = value.replace(/[^0-9]/g, "");
    return hasLeadingPlus ? `+${digitsOnly}` : digitsOnly;
  };

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    let sanitizedValue = value;

    if (
      name === "acquirer.merchantID" ||
      name === "merchant.taxpayer_id" ||
      name === "acquirer.postalCode"
    ) {
      sanitizedValue = sanitizeNoSpaceValue(value);
    } else if (name === "merchant.business_phone") {
      sanitizedValue = sanitizeBusinessPhone(value);
    }

    handleChange({
      target: {
        name,
        value: sanitizedValue,
      },
    });
  };

  return (
    <GridContainer>
      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <SelectField
          id="acquirer.iso"
          name="acquirer.iso"
          fullWidth
          label="ISO"
          value={iso}
          options={isoOptions}
          required
          maxLength={3}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.acquirer?.iso}
          touched={touched.acquirer?.iso}
          disabled
          // helperText="Belongs to ISO or not"
        />
      </GridItem>

      {iso === "True" && (
        <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
          <TextField
            id="acquirer.isoID"
            name="acquirer.isoID"
            fullWidth
            label="ISO ID"
            value={isoID}
            onChange={handleChange}
            onBlur={handleBlur}
            required
            maxLength={4}
            error={errors.acquirer?.isoID}
            touched={touched.acquirer?.isoID}
            disabled
            helperText="ISO identifier"
          />
        </GridItem>
      )}

      {formType === "createEnrollment" && (
        <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
          <TextField
            id="acquirer.email"
            name="acquirer.email"
            fullWidth
            label="Email"
            value={email}
            onChange={handleChange}
            onBlur={handleBlur}
            required
            error={errors.acquirer?.email}
            touched={touched.acquirer?.email}
            disabled={readOnly}
            helperText="Email"
          />
        </GridItem>
      )}

      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <CurrencySelectField
          id="acquirer.currency"
          name="acquirer.currency"
          fullWidth
          label="Currency Code"
          value={currency}
          required
          maxLength={3}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.acquirer?.currency}
          touched={touched.acquirer?.currency}
          disabled
          // helperText="Transaction currency"
        />
      </GridItem>

      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <TextField
          id="acquirer.name"
          name="acquirer.name"
          fullWidth
          label="Merchant Name"
          value={name}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          maxLength={100}
          error={errors.acquirer?.name}
          touched={touched.acquirer?.name}
          disabled={readOnly}
          helperText="Merchant business name"
        />
      </GridItem>

      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <TextField
          id="acquirer.address"
          name="acquirer.address"
          fullWidth
          label="Address"
          value={address}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          maxLength={200}
          error={errors.acquirer?.address}
          touched={touched.acquirer?.address}
          disabled={readOnly}
          helperText="Business address"
        />
      </GridItem>

      {!isCreating && (
        <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
          <TextField
            id="acquirer.merchantID"
            name="acquirer.merchantID"
            fullWidth
            label="Merchant ID"
            value={merchantID}
            onBlur={handleBlur}
            maxLength={64}
            error={errors.acquirer?.merchantID}
            touched={touched.acquirer?.merchantID}
            // Merchant ID is not editable in this flow: auto-generated on create,
            // and always read-only when viewing/editing an existing merchant.
            disabled
            helperText="Merchant identifier (read-only)"
          />
        </GridItem>
      )}

      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <MccSelectField
          name="acquirer.mccID"
          value={mccID || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={errors.acquirer?.mccID}
          touched={touched.acquirer?.mccID}
          disabled={readOnly}
          helperText="Search by MCC code or category description"
        />
      </GridItem>

      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <TextField
          id="acquirer.city"
          name="acquirer.city"
          fullWidth
          label="City"
          value={city}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          maxLength={50}
          error={errors.acquirer?.city}
          touched={touched.acquirer?.city}
          disabled={readOnly}
          helperText="City name"
        />
      </GridItem>

      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <TextField
          id="acquirer.merchantState"
          name="acquirer.merchantState"
          fullWidth
          label="State"
          value={merchantState}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          maxLength={30}
          error={errors.acquirer?.merchantState}
          touched={touched.acquirer?.merchantState}
          disabled={readOnly}
          helperText="State or province"
        />
      </GridItem>

      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <TextField
          id="acquirer.postalCode"
          name="acquirer.postalCode"
          fullWidth
          label="Postal Code"
          value={postalCode}
          onChange={handleFieldChange}
          onBlur={handleBlur}
          required
          maxLength={20}
          inputProps={{ pattern: "\\S*" }}
          error={errors.acquirer?.postalCode}
          touched={touched.acquirer?.postalCode}
          disabled={readOnly}
          helperText="Postal or ZIP code"
        />
      </GridItem>

      {isoID && (
        <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
          <TextField
            id="merchant.legal_name"
            name="merchant.legal_name"
            fullWidth
            label="Legal Name"
            value={legal_name}
            onChange={handleChange}
            onBlur={handleBlur}
            maxLength={32}
            required
            error={errors.merchant?.legal_name}
            touched={touched.merchant?.legal_name}
            disabled={readOnly}
            helperText="Legal business name"
          />
        </GridItem>
      )}

      {showHoldingFields && (
        <>
          <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
            <TextField
              id="acquirer.holding"
              name="acquirer.holding"
              fullWidth
              label="Holding"
              value={holding}
              onChange={handleChange}
              onBlur={handleBlur}
              required
              maxLength={100}
              error={errors.acquirer?.holding}
              touched={touched.acquirer?.holding}
              disabled={readOnly}
              helperText="Holding company name"
            />
          </GridItem>

          <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
            <TextField
              id="acquirer.holdingId"
              name="acquirer.holdingId"
              fullWidth
              label="Holding ID"
              value={holdingId}
              onChange={handleChange}
              onBlur={handleBlur}
              required
              maxLength={20}
              error={errors.acquirer?.holdingId}
              touched={touched.acquirer?.holdingId}
              disabled={readOnly}
              helperText="Holding company identifier"
            />
          </GridItem>
        </>
      )}

      {isoID && (
        <>
          <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
            <TextField
              id="merchant.business_email"
              name="merchant.business_email"
              fullWidth
              label="Business Email"
              value={business_email}
              onChange={handleChange}
              onBlur={handleBlur}
              required
              error={errors.merchant?.business_email}
              touched={touched.merchant?.business_email}
              disabled={readOnly}
              helperText="Business email address"
            />
          </GridItem>

          <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
            <TextField
              id="merchant.business_phone"
              name="merchant.business_phone"
              fullWidth
              label="Business Phone"
              value={business_phone}
              onChange={handleFieldChange}
              onBlur={handleBlur}
              required
              maxLength={20}
              inputProps={{
                pattern: "^\\+?[0-9]*$",
                inputMode: "tel",
              }}
              error={errors.merchant?.business_phone}
              touched={touched.merchant?.business_phone}
              disabled={readOnly}
              helperText="Business phone number"
            />
          </GridItem>
        </>
      )}
      {formType === "createEnrollment" && (
        <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
          <SelectField
            id="merchant.business_type"
            name="merchant.business_type"
            fullWidth
            label="Business Type"
            value={business_type}
            options={businessTypeOptions(currency)}
            required
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.merchant?.business_type}
            touched={touched.merchant?.business_type}
            disabled={readOnly}
            helperText="Type of business entity"
          />
        </GridItem>
      )}
      {isoID && (
        <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
          <TextField
            id="merchant.taxpayer_id"
            name="merchant.taxpayer_id"
            fullWidth
            label="Taxpayer ID"
            value={taxpayer_id}
            onChange={handleFieldChange}
            onBlur={handleBlur}
            maxLength={20}
            inputProps={{ pattern: "\\S*" }}
            error={errors.merchant?.taxpayer_id}
            touched={touched.merchant?.taxpayer_id}
            disabled={readOnly}
            helperText="Tax identification number"
          />
        </GridItem>
      )}
    </GridContainer>
  );
};

export default AcquirerFields;
